// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Copy affordance on fenced code blocks (memo dev/78). The wrapper resets
   the .msgAgent pre-wrap inheritance so the button chrome lays out normally;
   the <pre> itself keeps the parent's \`.msgAgent pre\` styling. */
.V0VxrkEUOENblrC_pPcP {
  position: relative;
  white-space: normal;
}

/* Subtle-always-visible (hover-only reveal is undiscoverable and dead on
   touch); full opacity on block hover, keyboard focus, and while a feedback
   state is showing. Absolute overlay + translucent backdrop: zero layout
   shift, and the button never joins the <pre>'s horizontal scroll. */
.L49DT8lZdk0DxY4oRY6N {
  position: absolute;
  top: 5px;
  right: 5px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  min-height: 22px;
  padding: 2px 6px;
  border: 1px solid var(--curio-border);
  border-radius: 6px;
  background: rgba(247, 247, 248, 0.92);
  color: var(--curio-text-secondary);
  font-size: 0.68rem;
  line-height: 1;
  cursor: pointer;
  opacity: 0.55;
  transition: opacity 120ms ease;
}

.V0VxrkEUOENblrC_pPcP:hover .L49DT8lZdk0DxY4oRY6N,
.L49DT8lZdk0DxY4oRY6N:focus-visible,
.L49DT8lZdk0DxY4oRY6N.IvDGOvhdRpP9bzwk4GAx {
  opacity: 1;
}

.L49DT8lZdk0DxY4oRY6N.JO1_ntOzs4Ag62fwAkOZ {
  color: var(--curio-danger-text);
  border-color: var(--curio-danger-border);
}

.iDPKfEazwpiecdXYJcRQ:empty {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./src/components/agents/content/AgentCodeBlock.module.css"],"names":[],"mappings":"AAAA;;iEAEiE;AACjE;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;;qEAGqE;AACrE;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,qCAAqC;EACrC,kBAAkB;EAClB,qCAAqC;EACrC,kCAAkC;EAClC,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,aAAa;EACb,8BAA8B;AAChC;;AAEA;;;EAGE,UAAU;AACZ;;AAEA;EACE,+BAA+B;EAC/B,wCAAwC;AAC1C;;AAEA;EACE,aAAa;AACf","sourcesContent":["/* Copy affordance on fenced code blocks (memo dev/78). The wrapper resets\n   the .msgAgent pre-wrap inheritance so the button chrome lays out normally;\n   the <pre> itself keeps the parent's `.msgAgent pre` styling. */\n.block {\n  position: relative;\n  white-space: normal;\n}\n\n/* Subtle-always-visible (hover-only reveal is undiscoverable and dead on\n   touch); full opacity on block hover, keyboard focus, and while a feedback\n   state is showing. Absolute overlay + translucent backdrop: zero layout\n   shift, and the button never joins the <pre>'s horizontal scroll. */\n.copyBtn {\n  position: absolute;\n  top: 5px;\n  right: 5px;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  min-height: 22px;\n  padding: 2px 6px;\n  border: 1px solid var(--curio-border);\n  border-radius: 6px;\n  background: rgba(247, 247, 248, 0.92);\n  color: var(--curio-text-secondary);\n  font-size: 0.68rem;\n  line-height: 1;\n  cursor: pointer;\n  opacity: 0.55;\n  transition: opacity 120ms ease;\n}\n\n.block:hover .copyBtn,\n.copyBtn:focus-visible,\n.copyBtn.active {\n  opacity: 1;\n}\n\n.copyBtn.failed {\n  color: var(--curio-danger-text);\n  border-color: var(--curio-danger-border);\n}\n\n.feedback:empty {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"block": `V0VxrkEUOENblrC_pPcP`,
	"copyBtn": `L49DT8lZdk0DxY4oRY6N`,
	"active": `IvDGOvhdRpP9bzwk4GAx`,
	"failed": `JO1_ntOzs4Ag62fwAkOZ`,
	"feedback": `iDPKfEazwpiecdXYJcRQ`
};
export default ___CSS_LOADER_EXPORT___;
